import { createSlice } from '@reduxjs/toolkit'

const initialState = {
   data: null // untuk state sementara
}

const tempSlice = createSlice({
   name: 'temp',
   initialState: initialState,
   reducers: {
      setTempData: (state, action) => {
         state.data = action.payload
      },
      clearTempData: (state) => {
         state.data = null
      }
   }
})
export const { setTempData, clearTempData } = tempSlice.actions
export default tempSlice.reducer
